module.exports = __webpack_public_path__ + "img/info_not_processed.ccb4fa23.svg";